// extracted by mini-css-extract-plugin
export default {"boards":"Home_boards__kmNfL","boardsCard":"Home_boardsCard__I07C6","boardsHeader":"Home_boardsHeader__ljKrh","boardsCardLine":"Home_boardsCardLine__TWlWg"};